// Switch.js
import React from "react";
import styled from "styled-components";

const SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 30px; /* metade da largura original */
  height: 17px; /* metade da altura original */
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    /* background-color: #4caf50; */
    background-color: #792783;
  }

  &:checked + span:before {
    transform: translateX(13px); /* metade do deslocamento original */
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 17px; /* metade da altura */

  &:before {
    position: absolute;
    content: "";
    height: 13px; /* metade do círculo */
    width: 13px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export default function Switch({
  checked,
  onChange = () => {},
  disabled = false,
  readOnly = false,
}) {
  return (
    <SwitchContainer>
      <SwitchInput
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
      />
      <Slider />
    </SwitchContainer>
  );
}
